exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title__wrapper__woEWb{z-index:100;margin-top:18px;margin-left:18px;transition:opacity .2s,visibility .2s;color:#fff;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:-wix-fonts-textFont-decoration}.title__title__3sCDq{font-size:14px;line-height:14px}.title__at-full-screen__kyDGZ .title__title__3sCDq{top:24px;left:24px;right:276px;font-size:20px;line-height:20px}@media (max-width:551px){.title__title__3sCDq{font-size:16px}}@media (max-width:401px){.title__title__3sCDq{font-size:14px}}@media (max-width:300px){.title__wrapper__woEWb{margin-left:12px;margin-right:12px}.title__title__3sCDq{font-size:12px}}", ""]);

// exports
exports.locals = {
	"wrapper": "title__wrapper__woEWb",
	"title": "title__title__3sCDq",
	"at-full-screen": "title__at-full-screen__kyDGZ",
	"atFullScreen": "title__at-full-screen__kyDGZ"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/player-widget/components/new-player/components/title/title.styl
// module id = 1642
// module chunks = 1 2 3